import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import PlayersView from 'views/players'; // Importing PlayersView component
import Filter from 'views/information/filter'; // Importing Filter component
import Table from 'views/information/table'; // Importing Table component
import Details from 'views/information/details'; // Importing Details component
import Record from 'views/information/record'; // Importing Record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Casino Report View.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the layout of the Casino Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current instance

        // Right section layout containing Record and Details components
        const right = {
            type: 'wide',
            rows: [Record, Details],
        };

        // Alternative right section layout for smaller screens
        const right2 = {
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [Record, Details],
        };

        // Toolbar configuration with pagination and export options
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar1',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select',
                    id: 'select',
                    options: ['10', '20', '50', '100', '1000'], // Options for number of items per page
                    width: 70,
                    on: {
                        onChange: function () {
                            // Update pager size and refresh datatable on selection change
                            $$('datatable').getPager().config.size = this.getValue() * 1;
                            $$('datatable').refresh();
                            $$('datatable').scrollTo(100, 0);
                        },
                    },
                },
                {
                    view: 'pager',
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export1',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export selection
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            var table = $$('datatable'); // Reference to the datatable
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index on current page
                            var last = first + size - 1; // Last item index on current page
                            if (value !== '') {
                                // Trigger export event with selected options
                                vthis.app.callEvent('export:filter', [{ value: value, first: first, last: last }]);
                            }
                        },
                    },
                },
            ],
        };

        // Second toolbar configuration for export options
        const toolbar2 = {
            view: 'toolbar',
            id: 'toolbar2',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {},
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export2',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export selection
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            if (value == 1) {
                                // Handle Excel export
                                var table = $$('datatable2'); // Reference to the second datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    // Remove format for columns with exportType
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format;
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) + 'Casino',
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                // Export to Excel with filename formatting
                                webix.toExcel(table, {
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Casino',
                                    ignore: { detailTittle: true, Type: true },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // Handle PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) + 'Casino',
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    // Export to PDF with filename formatting
                                    webix.toPDF($$('datatable2'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Casino',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            Type: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export2').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };

        // Left section layout containing filters and toolbars
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply current theme
                    elements: [
                        { view: 'label', label: _('Reporte de Casino') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Filter component
                Table, // Table component
                toolbar, // First toolbar
                toolbar2, // Second toolbar
            ],
        };

        // Advanced details section in an accordion
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Advanced details header
            ],
        };

        // Responsive advanced details section for smaller screens
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    minWidth: 250,
                    on: {
                        onItemClick: function () {
                            var height;
                            $$(function () {
                                // Adjust scrolling based on accordion state
                                height =
                                    $$('.scrolling > .webix_scroll_cont').height() -
                                    $$('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $$('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                } else {
                                    $$('a5').scrollTo(100, 0);
                                    height =
                                        $$('.scrolling > .webix_scroll_cont').height() -
                                        $$('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $$('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Main layout configuration for the view
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section
                        { id: 'res', view: 'resizer' }, // Resizer between sections
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 layout for small screens
                            : avanc, // Use advanced layout for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the Casino Report View.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            // Hide search button on small screens
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide();
            }
            // Adjust layout for small screens
            if (screen.width < 500 || screen.height < 500) {
                $$('res').hide(); // Hide resizer
                var childs = $$('toolbar1').getChildViews(); // Get child views of toolbar1
                $$('toolbar1').removeView(childs[2]); // Remove export select from toolbar1
                $$('pagerA').define('group', 1); // Define pager group
            }
            // jQuery function to calculate scroll bottom position
            $.fn.scrollBottom = function () {
                return $$(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
